module.exports = require("@openworklabs/filecoin-address");